import { useState } from 'react';

/** Tracks retry busy state around a React Query `refetch`. */
export function useQueryRetry(refetch: () => Promise<unknown>) {
  const [isRetrying, setIsRetrying] = useState(false);

  const retry = async () => {
    setIsRetrying(true);
    try {
      await refetch();
    } finally {
      setIsRetrying(false);
    }
  };

  return { isRetrying, retry };
}
